import { HomeAddress } from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/HomeAddress';
import { ShippingAddress } from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/ShippingAddress';
import OrderReview from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/OrderReview';
import { Confirmation } from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/Confirmation';
import { OrderError } from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/OrderError';
import Payment from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/Payment';
import PhoneVerification from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/PhoneVerification';
import TwoFAHelp from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/TwoFAHelp';

import { CHECKOUT_STEP_NAMES as STEP_NAMES } from '../constants';

const stepsContent = {
    [STEP_NAMES.SHIPPING_ADDRESS]: {
        name: STEP_NAMES.SHIPPING_ADDRESS,
        onSubmit: () => Promise.resolve(),
        component: ShippingAddress,
        title: 'NEW_CHECKOUT_SHIPPING_TITLE',
        subTitle: 'NEW_CHECKOUT_SHIPPING_SUB_TITLE',
        addBtn: 'NEW_CHECKOUT_ADD_SHIPPING_ADDRESS',
        ctaContent: 'NEW_CHECKOUT_SHIPPING_CTA',
        productsInCart: true,
        stepIndex: 1,
    },
    [STEP_NAMES.HOME_ADDRESS]: {
        name: STEP_NAMES.HOME_ADDRESS,
        onSubmit: () => Promise.resolve(),
        component: HomeAddress,
        title: 'NEW_CHECKOUT_HOME_TITLE',
        subTitle: 'NEW_CHECKOUT_HOME_SUB_TITLE',
        sameBtn: 'NEW_CHECKOUT_HOME_SAME_BTN',
        addBtn: 'NEW_CHECKOUT_HOME_ADD_BTN',
        ctaContent: 'NEW_CHECKOUT_HOME_CONFIRM_BTN',
        productsInCart: true,
        stepIndex: 2,
    },
    [STEP_NAMES.PHONE_VERIFICATION]: {
        name: STEP_NAMES.PHONE_VERIFICATION,
        heading: 'NEW_CHECKOUT_PHONE_VERIFICATION_HEADING',
        subHeading: 'NEW_CHECKOUT_PHONE_VERIFICATION_SUBHEADING',
        tip: 'NEW_CHECKOUT_PHONE_VERIFICATION_TIP',
        button: 'NEW_CHECKOUT_PHONE_VERIFICATION_HELP_LINK',
        component: PhoneVerification,
        onSubmit: () => Promise.resolve(),
        productsInCart: true,
        stepIndex: 2,
    },
    [STEP_NAMES.TWOFA_HELP]: {
        name: STEP_NAMES.TWOFA_HELP,
        heading: 'NEW_CHECKOUT_2FA_HELP_HEADING',
        subHeading: 'NEW_CHECKOUT_2FA_HELP_SUBHEADING',
        buttonSecondary: 'NEW_CHECKOUT_2FA_HELP_BACK_BTN',
        component: TwoFAHelp,
        onSubmit: () => Promise.resolve(),
        productsInCart: true,
        stepIndex: 2,
    },
    [STEP_NAMES.PAYMENT_METHODS]: {
        name: STEP_NAMES.PAYMENT_METHODS,
        title: 'NEW_CHECKOUT_ADD_PAYMENT_TITLE',
        subTitle: 'NEW_CHECKOUT_ADD_PAYMENT_SUB_TITLE',
        component: Payment,
        onSubmit: () => Promise.resolve(),
        productsInCart: true,
        stepIndex: 3,
    },
    [STEP_NAMES.ORDER_SUMMARY]: {
        name: STEP_NAMES.ORDER_SUMMARY,
        heading: 'NEW_CHECKOUT_SUMMARY_HEADING',
        component: OrderReview,
        onSubmit: () => Promise.resolve(),
        productsInCart: false,
        stepIndex: 4,
    },
    [STEP_NAMES.ORDER_ERROR]: {
        name: STEP_NAMES.ORDER_ERROR,
        heading: 'NEW_CHECKOUT_ERROR_TITLE',
        content: 'NEW_CHECKOUT_ERROR_CONTENT',
        ctaContent: 'NEW_CHECKOUT_BACK_TO_REVIEW',
        component: OrderError,
        productsInCart: false,
        stepIndex: 4,
    },
    [STEP_NAMES.ORDER_CONFIRMATION]: {
        name: STEP_NAMES.ORDER_CONFIRMATION,
        heading: 'NEW_CHECKOUT_CONFIRMATION_TITLE',
        subTitle: 'NEW_CHECKOUT_CONFIRMATION_SUB_TITLE',
        component: Confirmation,
        onSubmit: () => Promise.resolve(),
        productsInCart: false,
        stepIndex: 5,
    },
};

export default stepsContent;
